import { useState, useEffect } from 'react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { Storefront } from '@phosphor-icons/react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('nx_token')}` } });

export default function CreatorMarketplaceCardPage() {
  const [card, setCard] = useState(null);
  useEffect(() => { axios.get(`${API}/creator/marketplace-card`, auth()).then(r => setCard(r.data)).catch(() => {}); }, []);

  return (
    <DashboardLayout>
      <div className="space-y-5" data-testid="creator-marketplace-card">
        <div>
          <h1 className="font-display text-2xl font-black text-[var(--text-primary)] tracking-tight">My Marketplace Card</h1>
          <p className="text-sm text-[var(--text-secondary)] mt-1">Your discoverable profile — how brands find you</p>
        </div>
        {card && (
          <div className="nx-metric-card rounded-md max-w-lg">
            <div className="flex items-center gap-2 mb-4"><span className="encrypted-badge">Verified Profile</span>
              {card.linkedin?.b2b_badge && <span className="px-2 py-0.5 text-[8px] bg-[var(--accent-light)] text-[var(--accent)] rounded font-mono">B2B Creator</span>}
            </div>
            <div className="space-y-3">
              {[['Niche', card.niche], ['Market', card.market], ['Languages', card.content_languages?.join(', ')], ['Pricing', card.pricing_model]].map(([l, v]) => (
                <div key={l} className="flex items-center justify-between"><span className="text-xs text-[var(--text-tertiary)]">{l}</span><span className="text-xs text-[var(--text-primary)]">{v}</span></div>
              ))}
              <div className="flex items-center justify-between"><span className="text-xs text-[var(--text-tertiary)]">SoM Score</span><span className="text-sm font-bold text-[var(--accent)] font-mono">{card.personal_som}%</span></div>
              <div className="flex items-center justify-between"><span className="text-xs text-[var(--text-tertiary)]">Conv Rate</span><span className="text-sm font-bold text-[var(--success)] font-mono">{card.affiliate_conv_rate}%</span></div>
              <div className="flex items-center justify-between"><span className="text-xs text-[var(--text-tertiary)]">Engagement</span><span className="text-sm font-bold text-[var(--text-primary)] font-mono">{card.engagement_score}/100</span></div>
              {card.linkedin?.followers && <div className="flex items-center justify-between"><span className="text-xs text-[var(--text-tertiary)]">LinkedIn Followers</span><span className="text-sm font-bold text-[var(--text-primary)] font-mono">{card.linkedin.followers.toLocaleString()}</span></div>}
              <div className="flex items-center justify-between"><span className="text-xs text-[var(--text-tertiary)]">Primary Platform</span><span className="text-xs text-[var(--text-primary)]">{card.linkedin?.primary_platform || 'Instagram'}</span></div>
              {card.linkedin?.niche_tags && <div className="flex flex-wrap gap-1 mt-2">{card.linkedin.niche_tags.map(t => <span key={t} className="nx-tag nx-tag-blue text-[7px]">{t}</span>)}</div>}
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}
